import { Box, Button, Typography, Paper, Container } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { appStates, setAppState } from "../redux/features/appStateSlice";
import { nextViewConnectBusinessState } from "../redux/features/connectBusinessStateSlice";

export const ConnectIndividualWelcomeMessage = ({ name = "User" }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userState = useSelector((state) => state.userState);
  const fullName = `${userState.firstName || ""} ${userState.lastName || ""}`;

  const handleSubmit = () => {
    dispatch(setAppState({ currState: appStates.INITIALCOVERAGE }));
    dispatch(nextViewConnectBusinessState());
    navigate("/workforce/coverage-areas");
  };

  return (
    <Container maxWidth="sm" sx={{ mt: { xs: 4, md: 12 } }}>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 4, md: 6 },
          borderRadius: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          border: "1px solid var(--fx-surface-border, #E2E8F0)",
          backgroundColor: "var(--fx-surface-base, #FFFFFF)",
        }}
      >

        <Box
          component="img"
          src={require("../assets/images/markArea.png")}
          alt="Mark Area"
          sx={{ width: 120, height: 120, mb: 3 }}
        />

        <Typography variant="h4" sx={{ fontWeight: 800, color: "var(--fx-surface-text, #0F172A)", mb: 2 }}>
          Welcome, {fullName}
        </Typography>

        <Typography variant="body1" sx={{ color: "var(--fx-surface-textsecondary, #64748B)", mb: 4, maxWidth: "80%" }}>
          We're excited to have you on board. To get started, please define your preferred working area.
        </Typography>

        <Button
          variant="contained"
          size="large"
          onClick={handleSubmit}
          sx={{
            borderRadius: 50,
            px: 6,
            py: 1.5,
            textTransform: "none",
            fontSize: "1rem",
            backgroundColor: "#2d2fb8",
            boxShadow: "0 4px 14px rgba(45, 47, 184, 0.3)",
            "&:hover": {
              backgroundColor: "#232490",
              boxShadow: "0 6px 20px rgba(45, 47, 184, 0.4)",
            },
          }}
        >
          Set Working Area
        </Button>
      </Paper>
    </Container>
  );
};